// 路由设置
import Vue from "vue";
import Router from "vue-router";

// 获取用户信息（鉴权）
import ADMIN from "@/api/admin";
import store from "@/store";

const routes = [
  {
    name: "后台主页",
    path: "/",
    component: () => import("@/pages/admin"),
    redirect: "/control",
    children: [
      {
        name: "INDEX",
        path: "/index.html",
        redirect: "/control"
      },
      {
        sort: 1,
        name: "管理控制台",
        path: "/control",
        component: () => import("@/pages/main/control/control"),
        meta: {
          icon: "el-icon-monitor",
          menu: true
        }
      },
      {
        sort: 2,
        name: "系统安全",
        path: "/security",
        component: { render: h => h("router-view") },
        redirect: "/security/auth",
        meta: {
          icon: "el-icon-user",
          menu: true
        },
        children: [
          {
            name: "授权管理",
            path: "/security/auth",
            component: () => import("@/pages/main/security/auth/auth"),
            meta: { menu: true }
          },
          {
            name: "操作日志",
            path: "/security/log",
            component: () => import("@/pages/main/security/log/log"),
            meta: { menu: true }
          }
        ]
      },
      {
        sort: 3,
        name: "LDAP管理",
        path: "/ldap",
        component: () => import("@/pages/ldap"),
        props: route => ({ hex: route.query.h, keyword: route.query.k }),
        meta: {
          icon: "el-icon-notebook-2",
          menu: true
        }
      },
      {
        sort: 4,
        name: "任务管理",
        path: "/task",
        component: { render: h => h("router-view") },
        redirect: "/task/running",
        meta: {
          icon: "el-icon-date",
          menu: true
        },
        children: [
          {
            name: "任务队列",
            path: "/task/running",
            component: () => import("@/pages/task/running"),
            meta: { menu: true }
          },
          {
            name: "任务记录",
            path: "/task/history",
            component: () => import("@/pages/task/history"),
            props: route => ({
              timer: false,
              page: route.query.page,
              stime: route.query.stime,
              etime: route.query.etime
            }),
            meta: { menu: true }
          },
          {
            name: "定时任务",
            path: "/task/timer",
            component: () => import("@/pages/task/history"),
            props: route => ({
              timer: true,
              page: route.query.page,
              stime: route.query.stime,
              etime: route.query.etime
            }),
            meta: { menu: true }
          },
          {
            name: "任务详情",
            path: "/task/detail/:id",
            component: () => import("@/pages/task/detail"),
            props: route => ({ page: route.query.page, id: route.params.id })
          },
          {
            name: "变更历史",
            path: "/task/track",
            component: () => import("@/pages/task/track"),
            props: route => ({ page: route.query.page }),
            meta: { menu: true }
          }
        ]
      },
      {
        sort: 5,
        name: "系统设置",
        path: "/setting",
        component: () => import("@/pages/setting"),
        meta: {
          icon: "el-icon-setting",
          menu: true
        }
      },
      {
        sort: 6,
        name: "菜单设置",
        path: "/menusetting",
        component: () => import("@/pages/setting/menusetting"),
        meta: {
          icon: "el-icon-s-operation",
          menu: false
        }
      },
      {
        sort: 10,
        name: "扩展邮件列表",
        path: "/maillist",
        component: { render: h => h("router-view") },
        redirect: "/maillist/preview",
        children: [
          {
            name: "结果预览",
            path: "/maillist/preview",
            component: () => import("@/pages/maillist/preview")
          }
        ]
      },
      {
        sort: 9,
        name: "扩展设置",
        path: "/plugin",
        component: () => import("@/pages/plugin/setting"),
        meta: {
          icon: "el-icon-copy-document",
          menu: true
        }
      },
      {
        name: "扩展组件配置",
        path: "/plugin/:extension",
        component: () => import("@/pages/plugin")
      },
      /*  {
        sort: 11,
        name: "邮箱列表",
        path: "/email/list",
        component: () => import("@/pages/email/list"),
        meta: {
          icon: "el-icon-edit-outline",
          menu: true
        }
      }, */
      {
        sort: 12,
        name: "日志管理",
        path: "/log",
        component: { render: h => h("router-view") },
        redirect: "/log/sync",
        meta: {
          icon: "el-icon-edit-outline",
          menu: true
        },
        children: [
          {
            name: "同步日志",
            path: "/log/sync",
            component: () => import("@/pages/userlog/emaillog/log"),
            meta: { menu: true }
          },
          {
            name: "登录日志",
            path: "/log/login",
            component: () => import("@/pages/userlog/login/login"),
            meta: { menu: true }
          },
          {
            name: "操作日志",
            path: "/log/behavior",
            component: () => import("@/pages/userlog/behavior/log"),
            meta: { menu: true }
          }
        ]
      },
      {
        sort: 13,
        name: "数据分析",
        path: "/analysis",
        component: { render: h => h("router-view") },
        redirect: "/analysis/data",
        //component: () => import("@/pages/data/analysis"),
        meta: {
          icon: "el-icon-s-data",
          menu: true
        },
        children: [
          {
            name: "本地邮箱",
            path: "/analysis/data",
            component: () => import("@/pages/analysis/adlist"),
            meta: { menu: true }
          },
          {
            name: "网易邮箱",
            path: "/analysis/email",
            component: () => import("@/pages/analysis/emaillist"),
            meta: { menu: true }
          }
        ]
      },
      {
        sort: 14,
        name: "关于系统",
        path: "/system",
        component: () => import("@/pages/system/index"),
        meta: {
          icon: "el-icon-s-grid",
          menu: true
        }
      }
    ]
  },

  {
    name: "独立结果预览",
    path: "/sync/maillist/preview",
    component: () => import("@/pages/maillist/preview")
  },
  {
    path: "*", // 404 页面
    component: () => import("@/pages/error/not-found") // 或者使用component也可以的
  }
];
Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  routes,
  mode: "history"
});

router.beforeEach(async (to, from, next) => {
  // 用户信息抓取，权限检测

  if (to.path === "/accountcheck") {
    next();
  }
  if (store.getters.user === null) {
    let response = await ADMIN.USER();
    if (response.status === 200 && response.data) {
      await store.dispatch("setUser", response.data);
    } else {
      return;
    }
  }
  next();
});

window.VUE_ROUTER_PUSH = location => {
  router.push(location);
};

export default router;
